// styling
import styles from './styles.module.scss';

// components
import LazyImage from '@components/LazyImage';

// hooks
import {useThemeProvider} from '@contexts/themeContext';

// assets
import zidane from '@assets/zidane.webp';
import lacoruna from '@assets/clubs/lacoruna.webp';
import PropTypes from 'prop-types';

const Coach = ({coach, team}) => {
    const {direction} = useThemeProvider();
    const coachName = typeof coach === 'string' ? coach : coach?.name;
    const nameParts = (coachName || 'Head coach').trim().split(/\s+/);
    const firstName = nameParts.shift();
    const lastName = nameParts.join(' ');
    const coachImage = coach?.image_url ?? coach?.imageURL ?? coach?.image ?? zidane;
    const teamLogo = team?.logo ?? team?.image ?? lacoruna;
    const teamName = team?.team_name ?? team?.name ?? 'Team';

    return (
        <div className="card h-1 border-color-bottom card-padded p-relative" style={{borderColor: 'var(--accent)'}}>
            <div className={`${styles.media} ${styles[direction]}`}>
                <img src={coachImage} alt={coachName || 'Head coach'}/>
            </div>
            <div className="d-flex flex-column justify-content-between h-100">
                <div className="d-flex flex-column g-4">
                    <span className="text-12">Head coach</span>
                    <h3>{firstName} {lastName && <span className={styles.lastName}>{lastName}</span>}</h3>
                </div>
                <LazyImage className="club-logo club-logo--md" src={teamLogo} alt={teamName}/>
            </div>
        </div>
    )
}

Coach.propTypes = {
    coach: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    team: PropTypes.object,
};

export default Coach
